var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstados(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_61_9",
    "data-name": "Componente 61 \\u2013 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_271",
    "data-name": "Rect\\xE1ngulo 271",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "select_check_box_FILL0_wght300_GRAD0_opsz40",
    d: "M142.458-793.295a2.364,2.364,0,0,1-1.733-.724,2.364,2.364,0,0,1-.724-1.733v-21.79a2.365,2.365,0,0,1,.724-1.733,2.365,2.365,0,0,1,1.733-.724h20.736a.953.953,0,0,1,.7.285.962.962,0,0,1,.283.707.946.946,0,0,1-.283.7.961.961,0,0,1-.7.28H142.458a.47.47,0,0,0-.347.136.471.471,0,0,0-.136.347v21.79a.47.47,0,0,0,.136.347.471.471,0,0,0,.347.136h21.79a.47.47,0,0,0,.347-.136.47.47,0,0,0,.136-.347V-807.51a.953.953,0,0,1,.285-.7.962.962,0,0,1,.707-.283.946.946,0,0,1,.7.283.961.961,0,0,1,.28.7v11.758a2.364,2.364,0,0,1-.724,1.733,2.364,2.364,0,0,1-1.733.724Zm10.164-8.97,13.721-13.721a.933.933,0,0,1,.684-.284.943.943,0,0,1,.687.284.929.929,0,0,1,.287.686.926.926,0,0,1-.292.687l-14.241,14.251a1.184,1.184,0,0,1-.862.368,1.178,1.178,0,0,1-.86-.368l-6.384-6.384a.963.963,0,0,1-.292-.687.935.935,0,0,1,.292-.7.953.953,0,0,1,.695-.3.953.953,0,0,1,.695.3Z",
    transform: "translate(-138.002 822.998)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstados);
export default __webpack_public_path__ + "static/media/estados.44f8fedd82d9ede4eefbbb20ac78e8ba.svg";
export { ForwardRef as ReactComponent };